import React from 'react';
import classNames from 'classnames';

import Spinner from '@johnlewispartnership/wtr-ingredients/ingredients/Spinner';
import TrolleySize from '../TrolleySize';
import styles from './TrolleyButtonContents.scss';

type Props = {
  estimatedCost?: string;
  loadingStatus?: boolean;
  showMinSpend?: boolean;
};

const TrolleyButtonContents = ({
  estimatedCost = '',
  loadingStatus = false,
  showMinSpend = false,
}: Props) => (
  <div className={styles.buttonWrapper} data-trolley-loading={loadingStatus} aria-hidden="true">
    {loadingStatus && (
      <div className={styles.spinnerOverlay}>
        <Spinner isActive size="small" />
      </div>
    )}
    <span className={styles.trolleySizeWrapper}>
      <TrolleySize />
    </span>
    <span className={styles.totalText}>Total</span>
    <span
      className={classNames(styles.pricing, {
        [styles.showMinSpend]: showMinSpend,
      })}
      data-testid="total-price-overview"
    >
      {estimatedCost}
    </span>
  </div>
);

export default TrolleyButtonContents;
